import type { Finding, FindingCategory, FindingSeverity } from "./Finding";
import { hasImpact } from "./hasImpact";
import { isImportant } from "./isImportant";
import { worstSeverity } from "./worstSeverity";

// Оценка секции: худшая среди её важных находок. Мелочи вроде бонусов из ящиков видны внутри
// секции, но не красят её: «Фарм» с душами как у сильных — зелёный. Нет важных — `good`.
export const sectionSeverity = (
  findings: readonly Finding[],
  category: FindingCategory,
): FindingSeverity => {
  const rated = hasImpact(findings);
  return (
    worstSeverity(
      findings.filter(
        (finding) =>
          finding.category === category &&
          (finding.severity === "good" || isImportant(finding, rated)),
      ),
    ) ?? "good"
  );
};
